export enum SignupContainerEnums {
  HEADING_1 = 'Measure',
  HEADING_2 = 'Improve',
  HEADING_3 = 'Communicate',
  SEPARATOR = '•',
  SUBHEADING = 'Trusted Carbon Intelligence for Canadian Food and Beverage Companies'
}